/**
 * CUADevToolsPanel — DEV-only trigger panel for testing CUA events
 * Reference: TASK-UI-CU-012-1, SOL-UI-CU-012
 */

import React, { useState } from 'react';

/**
 * Panel only visible in DEV mode.
 * Dispatches CustomEvent for dev event simulation.
 */
export function CUADevToolsPanel() {
  // Return null in production
  if (!import.meta.env.DEV) return null;

  return <CUADevToolsPanelInner />;
}

function CUADevToolsPanelInner() {
  const [isOpen, setIsOpen] = useState(false);

  function dispatchDevEvent(type: string, detail: Record<string, unknown>) {
    window.dispatchEvent(new CustomEvent('__cua_dev_event', { detail: { type, ...detail } }));
  }

  function triggerLoopEvent() {
    dispatchDevEvent('agent.cua.loop.detected', {
      session_id: 'dev-session-001',
      reason: '[DEV] Detected repeated click loop on the same element',
      pa: 'pa2',
    });
  }

  function triggerConfirmRequest() {
    dispatchDevEvent('cua.confirm_request', {
      session_id: 'dev-session-001',
      request_id: `req-${Date.now()}`,
      action: 'click',
      target: 'Submit button at (412, 280)',
      description: '[DEV] Click Submit to submit the form',
      risk_level: 'write',
      timeout_sec: 30,
    });
  }

  return (
    <div
      data-testid="cua-devtools-panel"
      className="fixed bottom-4 right-16 z-50"
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="bg-primary text-primary-foreground text-xs px-3 py-1.5 rounded-full shadow-lg hover:bg-primary/90 transition-colors font-mono"
        title="CUA Dev Tools"
      >
        🖥️ CUA Dev
      </button>

      {isOpen && (
        <div className="absolute bottom-8 right-0 bg-surface-elevated border border-border rounded-xl shadow-xl p-4 space-y-3 min-w-[220px]">
          <p className="text-xs font-bold text-text-primary">CUA Dev Triggers</p>
          <div className="space-y-2">
            <button
              type="button"
              onClick={triggerLoopEvent}
              className="block w-full text-left text-xs bg-surface-neutral hover:bg-surface-elevated border border-border rounded px-3 py-2 transition-colors"
            >
              🔄 Trigger Loop Event
            </button>
            <button
              type="button"
              onClick={triggerConfirmRequest}
              className="block w-full text-left text-xs bg-surface-neutral hover:bg-surface-elevated border border-border rounded px-3 py-2 transition-colors"
            >
              ⚠️ Trigger Confirm Request
            </button>
          </div>
          <p className="text-[10px] text-muted">Only visible in DEV mode</p>
        </div>
      )}
    </div>
  );
}
